import React, { useState } from "react";
import { IconButton, Dialog, DialogTitle, DialogContent } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close"; // ไอคอนปุ่มปิด

const ImageCell = (params) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <IconButton onClick={() => setOpen(true)}>
          <ImageIcon />
        </IconButton>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <DialogTitle>
          รูปถ่ายชั่งน้ำหนัก
          <IconButton
            onClick={() => setOpen(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ textAlign: "center" }}>
          <img
            src={params.value}
            alt="รูปภาพ"
            style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageCell;
